module.exports = new __parcel__URL__("plan-timeline-skeleton.tpl.184c1195.svg").toString();